import { render } from "./DocumentEditor.vue?vue&type=template&id=f406dd4a"
import script from "./DocumentEditor.vue?vue&type=script&lang=js"
export * from "./DocumentEditor.vue?vue&type=script&lang=js"
script.render = render

export default script